import { IPageDataReducer } from '../reducers/pageData';
import { featureFlagEnabled } from './featureFlagEnabled';
import { DE_DOMAIN, C1AU_DOMAIN, CRUISE_AWAY_DOMAIN, C1UK_DOMAIN } from '../context/markets';

export const checkDirectBookingAvailability = (
    pageData: Pick<IPageDataReducer, 'brandConfig' | 'featureFlags'>,
) => {
    const featureFlags = pageData.featureFlags;
    const portalId = pageData.brandConfig.portalId;
    const isDreamlinesDE = portalId === DE_DOMAIN;
    const isCruiseAway = portalId === CRUISE_AWAY_DOMAIN;
    const isCruise1stAU = portalId === C1AU_DOMAIN;
    const isCruise1stUK = portalId === C1UK_DOMAIN;

    const isCruiseAwayDirectBookingFlowActive =
        isCruiseAway && featureFlagEnabled(featureFlags, 'directBookingAU');
    const isCruise1stAUDirectBookingFlowActive =
        isCruise1stAU && featureFlagEnabled(featureFlags, 'directBookingC1AU');
    const isCruise1stUKDirectBookingFlowActive =
        isCruise1stUK && featureFlagEnabled(featureFlags, 'directBookingC1UK');

    return (
        isDreamlinesDE ||
        isCruiseAwayDirectBookingFlowActive ||
        isCruise1stAUDirectBookingFlowActive ||
        isCruise1stUKDirectBookingFlowActive
    );
};
